// The kind of a cell modifier — extra rules layered over the board's cells.
export var CellModifierType;
(function (CellModifierType) {
    CellModifierType[CellModifierType["Connected"] = 0] = "Connected";
    CellModifierType[CellModifierType["LockPanel"] = 1] = "LockPanel";
    CellModifierType[CellModifierType["MetalBox"] = 2] = "MetalBox";
    CellModifierType[CellModifierType["Bolt"] = 3] = "Bolt";
    CellModifierType[CellModifierType["FrozenBox"] = 4] = "FrozenBox";
    CellModifierType[CellModifierType["LaserGate"] = 5] = "LaserGate";
    CellModifierType[CellModifierType["SlidingDoor"] = 6] = "SlidingDoor";
    CellModifierType[CellModifierType["SuperMysteryBox"] = 7] = "SuperMysteryBox";
    CellModifierType[CellModifierType["Elevator"] = 8] = "Elevator";
})(CellModifierType || (CellModifierType = {}));
// The game's numbers for the seals game-mechanics added (TWGS.Gameplay CellModifier). Mirrored by the
// constants of the same names on the backend's Gameplay/CellModifier.cs.
export const FROZEN_BOX_HITS = 2; // fresh ice: the first hit cracks it, the second shatters it
export const SUPER_MYSTERY_BOX_STAGES = 2; // closed -> half-open -> lifted; never authored
export const SLIDING_DOOR_MIN_LENGTH = 2; // a door one cell long would be a housing with no tape
export const LASER_GATE_MIN_LENGTH = 2; // two emitters, one box each
export const METAL_BOX_HITS = 3; // a fresh metal box: chain one snaps, chain two snaps, the plate pops
export const BOLT_LENGTH = 3; // what the game's bolt art is made for
export const BOLT_MIN_LENGTH = 2; // a head and a far end
export const ELEVATOR_SIZE = 2;
export var LaserKeyPairColor;
(function (LaserKeyPairColor) {
    LaserKeyPairColor[LaserKeyPairColor["Purple"] = 0] = "Purple";
    LaserKeyPairColor[LaserKeyPairColor["Blue"] = 1] = "Blue";
})(LaserKeyPairColor || (LaserKeyPairColor = {}));
export const LASER_PAIR_COLORS = [
    { v: LaserKeyPairColor.Purple, label: "Purple", hex: "#A61FEB" },
    { v: LaserKeyPairColor.Blue, label: "Blue", hex: "#02A3FD" },
];
